import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

export default function TitleAndDescription() {
  return (
    <Stack gap={{ xs: '4px', md: '8px' }}>
      <Text
        color="primary"
        family="secondary"
        size="2xl"
        weight="bold"
      >
        Transaction limits
      </Text>
      <Text
        color="secondary"
        size="lg"
      >
        Daily limits reset at 12am and monthly limits reset the first business day of the month.{' '}
      </Text>
    </Stack>
  );
}
